import { createContext } from 'react';

const nivel4Context = createContext();

export default nivel4Context;